import React, { useState } from "react";
import {
    useTopUpUserMutation,
    useTopUpUserTokenMutation,
    useTopUpCharityMutation,
    useChangeUserPasswordMutation,
    useAuthorizeInvestmentUserMutation,
} from "../store/api";
import { UserAutocomplete } from "./UserAutocomplete";
import { CharityAutocomplete } from "./CharityAutocomplete";

export const BalanceManagementSection: React.FC = () => {
    // States для форм
    const [topUpForm, setTopUpForm] = useState({
        user_ref_link: "",
        sum: "",
        additional_desc: "",
    });
    const [topUpTokenForm, setTopUpTokenForm] = useState({
        user_id: "",
        sum: "",
    });
    const [charityForm, setCharityForm] = useState({
        users_donate_id: "",
        sum: "",
    });
    const [passwordForm, setPasswordForm] = useState({
        user_id: "",
        password: "",
    });
    const [investAuthForm, setInvestAuthForm] = useState({
        user_id: "",
        url: "",
    });

    // Мутации
    const [topUp, { isLoading: isTopping }] = useTopUpUserMutation();
    const [topUpToken, { isLoading: isToppingToken }] =
        useTopUpUserTokenMutation();
    const [topUpCharityFn, { isLoading: isToppingCharity }] =
        useTopUpCharityMutation();

    const [changePass, { isLoading: isChanging }] =
        useChangeUserPasswordMutation();
    const [authorize, { isLoading: isAuthorizing }] =
        useAuthorizeInvestmentUserMutation();

    return (
        <div className="space-y-4">
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                Управление балансами и акциями
            </h2>

            {/* Пополнить счет юзеру (USDT) */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                    Пополнить счет юзеру (USDT)
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID / Ref Link
                        </label>
                        <UserAutocomplete
                            value={topUpForm.user_ref_link}
                            onChange={(value) =>
                                setTopUpForm({
                                    ...topUpForm,
                                    user_ref_link: value,
                                })
                            }
                            placeholder="Введите ID, email, имя, ref_link..."
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Сумма
                        </label>
                        <input
                            type="number"
                            value={topUpForm.sum}
                            onChange={(e) =>
                                setTopUpForm({
                                    ...topUpForm,
                                    sum: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="0.00"
                        />
                    </div>
                    <div className="flex-1 md:col-span-2">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Комментарий (additional_desc)
                        </label>
                        <input
                            type="text"
                            value={topUpForm.additional_desc}
                            onChange={(e) =>
                                setTopUpForm({
                                    ...topUpForm,
                                    additional_desc: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="Комментарий к пополнению (необязательно)"
                        />
                    </div>
                    <button
                        onClick={async () => {
                            if (topUpForm.user_ref_link && topUpForm.sum) {
                                try {
                                    await topUp({
                                        user_ref_link: topUpForm.user_ref_link,
                                        sum: parseFloat(topUpForm.sum),
                                        additional_desc:
                                            topUpForm.additional_desc.trim() ||
                                            undefined,
                                    }).unwrap();
                                    alert("Счёт пополнен успешно");
                                    setTopUpForm({
                                        user_ref_link: "",
                                        sum: "",
                                        additional_desc: "",
                                    });
                                } catch (error: any) {
                                    alert(
                                        "Ошибка: " +
                                            (error.data?.message ||
                                                error.message)
                                    );
                                }
                            }
                        }}
                        disabled={isTopping}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isTopping ? "Пополнение..." : "Пополнить"}
                    </button>
                </div>
            </div>

            {/* Пополнить ALNY токенами */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                    Пополнить ALNY токенами
                </h3>
                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID пользователя
                        </label>
                        <UserAutocomplete
                            value={topUpTokenForm.user_id}
                            onChange={(value) =>
                                setTopUpTokenForm({
                                    ...topUpTokenForm,
                                    user_id: value,
                                })
                            }
                            placeholder="Введите ID, email, имя..."
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Количество токенов
                        </label>
                        <input
                            type="number"
                            value={topUpTokenForm.sum}
                            onChange={(e) =>
                                setTopUpTokenForm({
                                    ...topUpTokenForm,
                                    sum: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="0"
                        />
                    </div>
                    <button
                        onClick={async () => {
                            if (topUpTokenForm.user_id && topUpTokenForm.sum) {
                                try {
                                    await topUpToken({
                                        user_id: parseInt(
                                            topUpTokenForm.user_id
                                        ),
                                        sum: parseFloat(topUpTokenForm.sum),
                                    }).unwrap();
                                    alert("Токены начислены успешно");
                                    setTopUpTokenForm({ user_id: "", sum: "" });
                                } catch (error: any) {
                                    alert(
                                        "Ошибка: " +
                                            (error.data?.message ||
                                                error.message)
                                    );
                                }
                            }
                        }}
                        disabled={isToppingToken}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isToppingToken ? "Начисление..." : "Начислить"}
                    </button>
                </div>
            </div>

            {/* Начислить на благо */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                    Начислить на благо
                </h3>
                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID благо / ID пользователя
                        </label>
                        <CharityAutocomplete
                            value={charityForm.users_donate_id}
                            onChange={(value) =>
                                setCharityForm({
                                    ...charityForm,
                                    users_donate_id: value,
                                })
                            }
                            placeholder="ID благо, ID пользователя, email, телефон..."
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Сумма
                        </label>
                        <input
                            type="number"
                            value={charityForm.sum}
                            onChange={(e) =>
                                setCharityForm({
                                    ...charityForm,
                                    sum: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="0.00"
                        />
                    </div>
                    <button
                        onClick={async () => {
                            if (
                                charityForm.users_donate_id &&
                                charityForm.sum
                            ) {
                                try {
                                    await topUpCharityFn({
                                        users_donate_id: parseInt(
                                            charityForm.users_donate_id
                                        ),
                                        sum: parseFloat(charityForm.sum),
                                    }).unwrap();
                                    alert("Начисление на благо выполнено");
                                    setCharityForm({
                                        users_donate_id: "",
                                        sum: "",
                                    });
                                } catch (error: any) {
                                    alert(
                                        "Ошибка: " +
                                            (error.data?.message ||
                                                error.message)
                                    );
                                }
                            }
                        }}
                        disabled={isToppingCharity}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isToppingCharity ? "Начисление..." : "Начислить"}
                    </button>
                </div>
            </div>

            {/* Смена пароля */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                    Смена пароля
                </h3>
                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID пользователя
                        </label>
                        <UserAutocomplete
                            value={passwordForm.user_id}
                            onChange={(value) =>
                                setPasswordForm({
                                    ...passwordForm,
                                    user_id: value,
                                })
                            }
                            placeholder="Введите ID, email, имя..."
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            Новый пароль
                        </label>
                        <input
                            type="text"
                            value={passwordForm.password}
                            onChange={(e) =>
                                setPasswordForm({
                                    ...passwordForm,
                                    password: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="Новый пароль"
                        />
                    </div>
                    <button
                        onClick={async () => {
                            if (passwordForm.user_id && passwordForm.password) {
                                try {
                                    await changePass({
                                        user_id: parseInt(passwordForm.user_id),
                                        password: passwordForm.password,
                                    }).unwrap();
                                    alert("Пароль изменён");
                                    setPasswordForm({
                                        user_id: "",
                                        password: "",
                                    });
                                } catch (error: any) {
                                    alert(
                                        "Ошибка: " +
                                            (error.data?.message ||
                                                error.message)
                                    );
                                }
                            }
                        }}
                        disabled={isChanging}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isChanging ? "Изменение..." : "Изменить"}
                    </button>
                </div>
            </div>

            {/* Авторизация в инвестициях */}
            <div className="bg-white dark:bg-gray-800 shadow rounded-lg p-4">
                <h3 className="text-xl font-semibold mb-2 text-gray-900 dark:text-white">
                    Авторизация в инвестициях
                </h3>
                <div className="flex gap-4 items-end">
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            ID пользователя
                        </label>
                        <UserAutocomplete
                            value={investAuthForm.user_id}
                            onChange={(value) =>
                                setInvestAuthForm({
                                    ...investAuthForm,
                                    user_id: value,
                                })
                            }
                            placeholder="Введите ID, email, имя..."
                        />
                    </div>
                    <div className="flex-1">
                        <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                            URL авторизации
                        </label>
                        <input
                            type="url"
                            value={investAuthForm.url}
                            onChange={(e) =>
                                setInvestAuthForm({
                                    ...investAuthForm,
                                    url: e.target.value,
                                })
                            }
                            className="w-full border border-gray-300 dark:border-gray-600 rounded-md px-4 py-2 bg-white dark:bg-gray-700 text-gray-900 dark:text-white"
                            placeholder="https://..."
                        />
                    </div>
                    <button
                        onClick={async () => {
                            if (investAuthForm.user_id && investAuthForm.url) {
                                try {
                                    await authorize({
                                        user_id: parseInt(
                                            investAuthForm.user_id
                                        ),
                                        url: investAuthForm.url,
                                    }).unwrap();
                                    alert("Пользователь авторизован");
                                    setInvestAuthForm({ user_id: "", url: "" });
                                } catch (error: any) {
                                    alert(
                                        "Ошибка: " +
                                            (error.data?.message ||
                                                error.message)
                                    );
                                }
                            }
                        }}
                        disabled={isAuthorizing}
                        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md disabled:opacity-50"
                    >
                        {isAuthorizing ? "Авторизация..." : "Авторизовать"}
                    </button>
                </div>
            </div>
        </div>
    );
};
